import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { AccountBreadcrumb } from '../../../../../../../../../features/registration/account/account-breadcrumb';
import { getRegistrationAccountDetailPath } from '../../../../../../../../../features/registration/account/registration-account-routing';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `account-${params.accountId}`,
        label: <AccountBreadcrumb accountId={params.accountId} displayIdOnly />,
        to: `${getRegistrationAccountDetailPath(params.accountId)}/asset`,
      }),
    }) satisfies AggregateBreadcrumb,
});
